<template>
<svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18Z" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 10C6.10457 10 7 9.10457 7 8C7 6.89543 6.10457 6 5 6C3.89543 6 3 6.89543 3 8C3 9.10457 3.89543 10 5 10Z" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 14C17.8954 14 17 14.8954 17 16C17 17.1046 17.8954 18 19 18C20.1046 18 21 17.1046 21 16C21 14.8954 20.1046 14 19 14Z" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 10C20.1046 10 21 9.10457 21 8C21 6.89543 20.1046 6 19 6C17.8954 6 17 6.89543 17 8C17 9.10457 17.8954 10 19 10Z" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 14C3.89543 14 3 14.8954 3 16C3 17.1046 3.89543 18 5 18C6.10457 18 7 17.1046 7 16C7 14.8954 6.10457 14 5 14Z" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
<script>
export default {
    name: 'EconomicGroupIcon',
    props: {
        size: {
            type: String,
            default: '24'
        },
        color: {
            type: String,
            default: '#3D5DFC'
        },
    }
}
</script>

<style>
</style>